var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArchiveBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 475.078 475.077",
    fill: "#B63D0D",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M438.536,146.177H36.547c-4.952,0-9.235,1.807-12.85,5.424c-3.617,3.615-5.424,7.898-5.424,12.847v274.084     c0,4.948,1.807,9.233,5.424,12.847c3.615,3.617,7.898,5.428,12.85,5.428h401.989c4.949,0,9.229-1.811,12.847-5.428     c3.614-3.613,5.421-7.898,5.421-12.847V164.448c0-4.952-1.8-9.231-5.421-12.847C447.769,147.984,443.485,146.177,438.536,146.177z      M286.927,232.113c-3.613,3.616-7.898,5.424-12.847,5.424h-73.089c-4.946,0-9.229-1.809-12.847-5.424     c-3.615-3.617-5.424-7.898-5.424-12.85c0-4.948,1.809-9.231,5.424-12.847c3.617-3.617,7.9-5.426,12.847-5.426h73.096     c4.945,0,9.227,1.809,12.847,5.426c3.614,3.615,5.421,7.898,5.421,12.847C292.355,224.214,290.544,228.496,286.927,232.113z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M469.658,23.695c-3.618-3.617-7.898-5.424-12.848-5.424H18.272c-4.948,0-9.231,1.807-12.847,5.424     C1.809,27.31,0,31.593,0,36.542v73.089c0,4.948,1.809,9.229,5.426,12.847c3.616,3.617,7.898,5.424,12.847,5.424h438.531     c4.948,0,9.233-1.807,12.854-5.424c3.613-3.617,5.42-7.898,5.42-12.847V36.542C475.078,31.59,473.271,27.31,469.658,23.695z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveBox);
export default __webpack_public_path__ + "static/media/archive_box.31c6efe6e9843dcb1e41bd077ed49f5a.svg";
export { ForwardRef as ReactComponent };